import { render, staticRenderFns } from "./DT_ReleaseHistory.vue?vue&type=template&id=3cd7e32b&scoped=true&"
import script from "./DT_ReleaseHistory.vue?vue&type=script&lang=js&"
export * from "./DT_ReleaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./Data_Tools.css?vue&type=style&index=0&id=3cd7e32b&prod&scoped=true&lang=css&"
import style1 from "./DT_ReleaseHistory.vue?vue&type=style&index=1&id=3cd7e32b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7e32b",
  null
  
)

export default component.exports